// Tabela mais densa que o DataTable padrão, para listas de 31 dias.

export const Tabela = ({ children, className = "" }) => (
  <div className={`overflow-x-auto ${className}`}>
    <table className="min-w-full divide-y divide-gray-200 text-sm">
      {children}
    </table>
  </div>
);

export const Th = ({ children, className = "" }) => (
  <th
    className={`whitespace-nowrap bg-gray-50 px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 ${className}`}
  >
    {children}
  </th>
);

export const Td = ({ children, className = "", ...props }) => (
  <td
    className={`whitespace-nowrap px-3 py-1.5 text-gray-700 ${className}`}
    {...props}
  >
    {children}
  </td>
);
